<div class="task-item">
    <div class="left">
        <div class="task-info">
            <span nz-icon [nzType]="'svg:'+ item.configIcon" nzTheme="outline" class="task-icon"></span>
            <span class="task-code" (click)="switchFullscreen()">{{ item.taskKey }}</span>
        </div>
        <div class="task-name" (click)="switchFullscreen()">{{ item.taskName }}</div>
    </div>
    <div class="right">
        <span *ngIf="item.priority" nz-icon [nzType]="'svg:'+ item.priority.toLowerCase()" nzTheme="outline" class="priority-icon" nz-tooltip [nzTooltipTitle]="item.priority"></span>
        <div class="avatar-group">
            <app-avatar-group [list]="item.assigneesInfo"></app-avatar-group>
        </div>

        <button nz-button nz-dropdown [nzDropdownMenu]="statusMenu" [nzLoading]="statusLoading" nzSize="small" nzType="text" class="status-button">
            {{ item.swimLaneName }}
            <span nz-icon nzType="down"></span>
        </button>
        <nz-dropdown-menu #statusMenu="nzDropdownMenu">
            <ul nz-menu>
                <li
                        nz-menu-item
                        *ngFor="let statusItem of swimLaneList"
                        [nzDisabled]="statusItem.id === item.swimLaneId"
                        (click)="changeTaskStatus(item, statusItem)"
                >
                    {{ statusItem.swimLaneName }}
                </li>
            </ul>
        </nz-dropdown-menu>
        <button nz-button nzSize="small" nz-tooltip nzTooltipTitle="Remove" class="task-remove" (click)="handleRemove()">
            <span nz-icon nzType="close"></span>
        </button>
    </div>
</div>
